import React from 'react';

import { cn } from '@/lib/shadcn/lib/utils';

type TypographyElementProps =
  React.HTMLAttributes<HTMLHeadingElement> | React.HTMLAttributes<HTMLParagraphElement>;

export type TypographyProps = {
  ref?: React.ForwardedRef<HTMLParagraphElement | HTMLHeadingElement>;
} & React.PropsWithChildren<TypographyElementProps>;

function h1({ children, className, ...props }: TypographyProps) {
  return (
    <h1 className={cn('text-h1', className)} {...props}>
      {children}
    </h1>
  );
}
function h2({ children, className, ...props }: TypographyProps) {
  return (
    <h2 className={cn('text-h2', className)} {...props}>
      {children}
    </h2>
  );
}

function h3({ children, className, ...props }: TypographyProps) {
  return (
    <h3 className={cn('text-h3', className)} {...props}>
      {children}
    </h3>
  );
}

function h4({ children, className, ...props }: TypographyProps) {
  return (
    <h4 className={cn('text-h4', className)} {...props}>
      {children}
    </h4>
  );
}

function h5({ children, className, ...props }: TypographyProps) {
  return (
    <h5 className={cn('text-h5', className)} {...props}>
      {children}
    </h5>
  );
}

function h6({ children, className, ...props }: TypographyProps) {
  return (
    <h6 className={cn('text-h6', className)} {...props}>
      {children}
    </h6>
  );
}

function p1({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-p1', className)} {...props}>
      {children}
    </p>
  );
}

function p2({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-p2', className)} {...props}>
      {children}
    </p>
  );
}

function p3({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-p3', className)} {...props}>
      {children}
    </p>
  );
}

function p4({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-p4', className)} {...props}>
      {children}
    </p>
  );
}

const p5 = React.forwardRef<HTMLParagraphElement, TypographyProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <p ref={ref} className={cn('text-p5', className)} {...props}>
        {children}
      </p>
    );
  },
);

function small1({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-small1', className)} {...props}>
      {children}
    </p>
  );
}

function small2({ children, className, ...props }: TypographyProps) {
  return (
    <p className={cn('text-small2', className)} {...props}>
      {children}
    </p>
  );
}

export const Typography = {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p1,
  p2,
  p3,
  p4,
  p5,
  small1,
  small2,
};
